import { useEffect, useState, useRef, MouseEvent } from "react";
import classNames from "classnames";
import { Link } from "./Links/Link";
import { MayorLink } from "./Links/MayorLink";
import styles from "./TopSection.module.scss";
import { baseLinks, LinkData } from "./Links/linksData";
import { shuffleArray } from "./Links/helpers";
import Text from "../../../presentational/Typography/Text";

export const TopSection = () => {
  const [links, setLinks] = useState<LinkData[]>([]);
  const linksContainerRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeftStart, setScrollLeftStart] = useState(0);

  useEffect(() => {
    setLinks(shuffleArray(baseLinks));
  }, []);

  const [isTopSectionVisible, setIsTopSectionVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 44) {
        setIsTopSectionVisible(false);
      } else {
        setIsTopSectionVisible(true);
      }
    };

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    if (!linksContainerRef.current) return;
    setIsDragging(true);
    setStartX(e.pageX - linksContainerRef.current.offsetLeft);
    setScrollLeftStart(linksContainerRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    if (!isDragging) return;
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    if (!isDragging) return;
    setIsDragging(false);
  };

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    if (!isDragging || !linksContainerRef.current) return;
    e.preventDefault();
    const x = e.pageX - linksContainerRef.current.offsetLeft;
    const walk = (x - startX);
    linksContainerRef.current.scrollLeft = scrollLeftStart - walk;
  };

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles["wrapper-hidden"]]: !isTopSectionVisible,
      })}
    >
      <div className={styles.container}>
        <div className={styles.mayor}>
          <MayorLink />
        </div>
        <div
          role="presentation"
          className={classNames(styles["links-container"], styles["no-select"])}
          ref={linksContainerRef}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          <div className={styles.links}>
            {links.map((link) => (
              <Link href={link.href} key={link.id} draggable={false}>
                <Text className={styles["link-text"]}>{link.title}</Text>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
